import React, { useState } from 'react';
import { Box, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import {
    calculateDiscountPercentage,
    getTotalUsedQuantity,
    getTotalOtherQuantity,
    getTotalExtendedPrice,
    priceFormatObj,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import {
    getPriceInNumberDataType,
    noPriceErrorMsg,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import { currencySymbol, isIpad, setCurrencyFormat } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPaddingLeft: {
        paddingLeft: '34px',
    },
}));

const RowTemplateTab = ({ item, itemIdx, adjustedPriceChangeHandler }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const iPad = isIpad();
    const textAlign = 'end';

    const unitPrice = getPriceInNumberDataType(item.basePrice);
    const [usedValue, setUsedValue] = useState(item.adjustedUsedQtyPrice);
    const [otherValue, setOtherValue] = useState(item.adjustedOtherQtyPrice);
    const usedQuantity = item.lotSerial && getTotalUsedQuantity(item.lotSerial);
    const otherQuantity =
        item.lotSerial && getTotalOtherQuantity(item.lotSerial);

    const isPriceNotAvailable = item.exclusionStatus === noPriceErrorMsg;

    useEffectWithErrorLogging(() => {
        if (
            !item.adjustedOtherQtyPrice &&
            !item.adjustedUsedQtyPrice &&
            !item.invalidUsedQtyAdjBasePriceMsg &&
            !item.invalidOtherQtyAdjBasePriceMsg
        ) {
            setOtherValue('');
            setUsedValue('');
        }
    }, [item]);

    const adjPriceInputStyleObj = {
        width: '102px',
        height: '33px',
        border: item.invalidUsedQtyAdjBasePriceMsg
            ? '2px solid #FACFD6'
            : '2px solid #EBEDED',
        padding: '6px 8px',
        borderRadius: 6,
        textAlign: 'end',
    };

    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <Grid container alignItems={'flex-start'}>
                    <Grid item xs={6}>
                        <div style={{ display: 'flex' }}>
                            <TextWithClicks
                                classes={classes}
                                media={{
                                    titleArea: 12,
                                    buttonnsArea: 0,
                                    xs: 3,
                                    lg: 2,
                                }}
                                leftTitle={item.cfn}
                            />
                            <TextWithClicks
                                marginRight={'350px'}
                                classes={classes}
                                media={{
                                    titleArea: 0,
                                    buttonnsArea: 12,
                                    xs: 3,
                                    lg: 2,
                                }}
                                justifyContentVal={'flex-end'}
                                typeNonTissue={
                                    item.salesOrg === 'S002'
                                        ? 'NT'
                                        : item.salesOrg === 'S030' && 'T'
                                }
                                typeEA={item.uom}
                            />
                        </div>
                        <CustomLabel
                            fSize={'12px !important'}
                            color={'#140F4B'}
                            letterSpacing={'0px !important'}
                            fWeight={'normal !important'}
                            label={item.description}
                            padding={'5px 0 15px'}
                        />
                    </Grid>
                    {usedQuantity && usedQuantity > 0 ? (
                        <>
                            <Grid
                                container
                                item
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Grid item xs={5} style={{ display: 'flex' }}>
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                    >
                                        {t('reportUsage.record.priceOverride.AccountOwnedList.index.used')} {usedQuantity}
                                    </StyledTextDiv>
                                    {item.adjustedUsedQtyPrice && (
                                        <StyledTextDiv
                                            color={'#E5047E'}
                                            fontSize={'12px'}
                                            marginLeft={'100px'}
                                        >
                                            {`${calculateDiscountPercentage(
                                                unitPrice,
                                                item.adjustedUsedQtyPrice
                                            )}${t('reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount')} `}
                                        </StyledTextDiv>
                                    )}
                                </Grid>
                                <Grid item xs={2}>
                                    {!isPriceNotAvailable && (
                                        <>
                                            <StyledTextDiv
                                                color={'#202124'}
                                                fontSize={'13px'}
                                                textAlign={textAlign}
                                                marginRight={'30px'}
                                            >
                                                {`${t('consignmentBilling.priceOverride.priceOverrideTable.adjPrice')} ${currencySymbol(
                                                    setCurrencyFormat(
                                                        item.basePrice
                                                    )
                                                )}`}
                                            </StyledTextDiv>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    textAlign: textAlign,
                                                }}
                                            >
                                                <input
                                                    id={`usedPriceInput-${itemIdx}`}
                                                    className="adjustedPriceInput"
                                                    placeholder={item.basePrice}
                                                    value={usedValue}
                                                    onChange={(e) =>
                                                        setUsedValue(
                                                            e.target.value
                                                        )
                                                    }
                                                    onKeyPress={(e) => {
                                                        if (!/[0-9.]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={
                                                        adjPriceInputStyleObj
                                                    }
                                                    onBlur={(e) =>
                                                        adjustedPriceChangeHandler(
                                                            e,
                                                            item,
                                                            itemIdx,
                                                            'used'
                                                        )
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    xs={2}
                                    style={{ marginRight: '13px' }}
                                >
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        textAlign={textAlign}
                                    >
                                        {t('consignmentBilling.priceOverride.priceOverrideTable.unitPrice')}
                                    </StyledTextDiv>
                                    <DiscountedPriceTemplate
                                        isPriceNotAvailable={
                                            isPriceNotAvailable
                                        }
                                        originalPrice={item.basePrice}
                                        adjustedPrice={
                                            item.adjustedUsedQtyPrice
                                        }
                                        modifiedPrice={
                                            item.adjustedUsedQtyPrice
                                                ? setCurrencyFormat(
                                                      item.adjustedUsedQtyPrice
                                                  )
                                                : item.basePrice
                                        }
                                        textAlign={textAlign}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        textAlign={textAlign}
                                        marginRight={!iPad && '16px'}
                                    >
                                        {t('consignmentBilling.priceOverride.priceOverrideTable.extPrice')}
                                    </StyledTextDiv>
                                    <DiscountedPriceTemplate
                                        isPriceNotAvailable={
                                            isPriceNotAvailable
                                        }
                                        originalPrice={item.usedQtyExtPrice}
                                        adjustedPrice={
                                            item.adjustedUsedQtyPrice
                                        }
                                        modifiedPrice={getTotalExtendedPrice(
                                            item.adjustedUsedQtyPrice
                                                ? item.adjustedUsedQtyPrice
                                                : item.basePrice,
                                            item.lotSerial,
                                            'used'
                                        )}
                                        textAlign={textAlign}
                                    />
                                </Grid>
                                {item.invalidUsedQtyAdjBasePriceMsg && (
                                    <Grid
                                        item
                                        xs={5}
                                        style={{ display: 'flex' }}
                                    ></Grid>
                                )}
                                {item.invalidUsedQtyAdjBasePriceMsg && (
                                    <Grid
                                        item
                                        xs={7}
                                        style={{
                                            display: 'flex',
                                            paddingTop: '1%',
                                            paddingLeft: '3.5%',
                                        }}
                                    >
                                        <AlertMsg
                                            message={
                                                item.invalidUsedQtyAdjBasePriceMsg
                                            }
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </>
                    ) : null}
                    {usedQuantity &&
                        usedQuantity > 0 &&
                        otherQuantity &&
                        otherQuantity > 0 && (
                            <Grid item xs={12} style={{ padding: '20px 0' }}>
                                <Divider orientation="horizontal" />
                            </Grid>
                        )}
                    {otherQuantity && otherQuantity > 0 ? (
                        <>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Grid item xs={5} style={{ display: 'flex' }}>
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                    >
                                    {t('reportUsage.record.priceOverride.AccountOwnedList.index.other')} {otherQuantity}
                                    </StyledTextDiv>
                                    {item.adjustedOtherQtyPrice && (
                                        <StyledTextDiv
                                            color={'#E5047E'}
                                            fontSize={'12px'}
                                            marginLeft={'100px'}
                                        >
                                            {`${calculateDiscountPercentage(
                                                unitPrice,
                                                item.adjustedOtherQtyPrice
                                            )}${t('reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount')} `}
                                        </StyledTextDiv>
                                    )}
                                </Grid>
                                <Grid item xs={2}>
                                    {!isPriceNotAvailable && (
                                        <>
                                            <StyledTextDiv
                                                color={'#202124'}
                                                fontSize={'13px'}
                                                textAlign={textAlign}
                                                marginRight={'30px'}
                                            >
                                                {`${t('consignmentBilling.priceOverride.priceOverrideTable.adjPrice')} ${currencySymbol(
                                                    setCurrencyFormat(
                                                        item.basePrice
                                                    )
                                                )}`}
                                            </StyledTextDiv>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    textAlign: textAlign,
                                                }}
                                            >
                                                <input
                                                    id={`otherPriceInput-${itemIdx}`}
                                                    className="adjustedPriceInput"
                                                    placeholder={item.basePrice.substring(
                                                        1
                                                    )}
                                                    value={otherValue}
                                                    onChange={(e) =>
                                                        setOtherValue(
                                                            e.target.value
                                                        )
                                                    }
                                                    onKeyPress={(e) => {
                                                        if (!/[0-9.]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={
                                                        adjPriceInputStyleObj
                                                    }
                                                    onBlur={(e) =>
                                                        adjustedPriceChangeHandler(
                                                            e,
                                                            item,
                                                            itemIdx,
                                                            'other'
                                                        )
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                </Grid>

                                <Grid
                                    item
                                    xs={2}
                                    style={{ marginRight: '13px' }}
                                >
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        textAlign={textAlign}
                                        marginRight={!iPad && '-5px'}
                                    >
                                        {t('consignmentBilling.priceOverride.priceOverrideTable.unitPrice')}
                                    </StyledTextDiv>
                                    <DiscountedPriceTemplate
                                        isPriceNotAvailable={
                                            isPriceNotAvailable
                                        }
                                        originalPrice={item.basePrice}
                                        adjustedPrice={
                                            item.adjustedOtherQtyPrice
                                        }
                                        modifiedPrice={
                                            item.adjustedOtherQtyPrice
                                                ? setCurrencyFormat(
                                                      item.adjustedOtherQtyPrice
                                                  )
                                                : item.basePrice
                                        }
                                        textAlign={textAlign}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <StyledTextDiv
                                        color={'#202124'}
                                        fontSize={'13px'}
                                        textAlign={textAlign}
                                        marginRight={!iPad && '16px'}
                                    >
                                        {t('consignmentBilling.priceOverride.priceOverrideTable.extPrice')}
                                    </StyledTextDiv>
                                    <DiscountedPriceTemplate
                                        isPriceNotAvailable={
                                            isPriceNotAvailable
                                        }
                                        originalPrice={item.otherQtyExtPrice}
                                        adjustedPrice={
                                            item.adjustedOtherQtyPrice
                                        }
                                        modifiedPrice={getTotalExtendedPrice(
                                            item.adjustedOtherQtyPrice
                                                ? item.adjustedOtherQtyPrice
                                                : item.basePrice,
                                            item.lotSerial,
                                            'other'
                                        )}
                                        textAlign={textAlign}
                                    />
                                </Grid>
                                {item.invalidOtherQtyAdjBasePriceMsg && (
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ display: 'flex' }}
                                    >
                                        <AlertMsg
                                            message={
                                                item.invalidOtherQtyAdjBasePriceMsg
                                            }
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </>
                    ) : null}
                </Grid>
            </Box>
        </>
    );
};

export default RowTemplateTab;
